<mat-accordion displayMode="flat">

    <mat-expansion-panel></mat-expansion-panel>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Tickets</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="tickets">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Lookup</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
            <ng-container>
                <a mat-list-item routerLink="tickets/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Assets</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="assets">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Lookup</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
            <ng-container>
                <a mat-list-item routerLink="assets/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Categories</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="categories">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Lookup</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
            <ng-container>
                <a mat-list-item routerLink="categories/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Users</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="users">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Browse</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="users/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Profiles</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="profiles">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Browse</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="profiles/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Tenants</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="tenants">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Browse</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="tenants/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>
    
    <mat-expansion-panel hideToggle></mat-expansion-panel>


  </mat-accordion>